import React from 'react';
import { motion } from 'framer-motion';
import classes from './Sumofame.module.scss';

import imgSunBg from '../../../../assets/images/sun-bg.svg';
import imgSunLight from '../../../../assets/images/sun-light.svg';
import imgSumofame from '../../../../assets/images/sumofame.svg';
import BigButton from '../../../UI/BigButton/BigButton';

const Sumofame = ({ colors, end, className, style }) => {
  // const [scrollable, setScrollable] = useState( window.innerWidth >= 875 ? false : true);

  // useEffect(()=> {
  //   const resizeHandler = ()=> {
  //     if (window.innerWidth <= 640 && !scrollable) setScrollable(true);
  //     else if (window.innerWidth > 640 && scrollable) setScrollable(false);
  //   }
  //   window.addEventListener('resize', resizeHandler);
  //   return ()=> window.removeEventListener('resize', resizeHandler);
  // }, [scrollable]);

  const rootClass = [classes.Sumofame];
  if (className) rootClass.push(className);
  // if (scrollable) rootClass.push('scrollable');

  return (
    <div className={rootClass.join(' ')} style={style ? style:{}}>
      {end && <motion.div className={classes.Bg}
        style={{ backgroundImage: `url(${imgSunBg})` }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.3 }}
      ></motion.div>}

      <div className={classes.Left}>
        {end && <div className={classes.ImageContainer}>
          <motion.img src={imgSunLight} alt="IMG" className={classes.LightBg} 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          />
          <motion.img src={imgSumofame} alt="IMG" className={classes.Image} 
            initial={{ rotate: -360*2, scale: 0 }}
            animate={{ rotate: 0, scale: 1 }}
          />
        </div>}
      </div>

      {end && <motion.div className={classes.Right}
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: 100, opacity: 0 }}
      >
        <div className={classes.TextContents}>
          <h4 className={classes.Title}>About this project</h4>
          <div className={classes.Details}>
            <p className={classes.Text}>
            A media promotion company, actively involved in the promotion of videos; youtube, web series, movie trailers, website articles, songs. With the promotion of some Tollywood and Kollywood blockbusters credited to us, sumofame has become the number one choice for those looking to get traffic, more views and streams for their work to reach across borders. A team of detailed creatives handle it. We have an exceptional understanding of how the media works; we push your movies, music videos, social media videos, with result-oriented methods. Promotions are with consistency and sustained efforts; you are sure to go viral.
            </p>

            <ul className={classes.Ul}>
              <li className={classes.Li}>Over 50 orders delivered monthly</li>
              <li className={classes.Li}>Promotion of website articles that need to be promoted for a certain amount of clicks (20,000 views /hour).</li>
              <li className={classes.Li}>Limitless range of ideas available to promote your videos and get the highest number of views.</li>
              <li className={classes.Li}>Promotion of web articles for a high number of clicks</li>
              <li className={classes.Li}>Most elevated views reached – 110 million</li>
            </ul>
          </div>
        </div>

        <div className={classes.Buttons}>
          <a href="https://www.sumofame.com" target="_blank" without rel="noopener noreferrer" className={classes.Link}>
            <BigButton style={{ color: colors[0], backgroundColor: colors[2] }} className={classes.Btn}>
              Visit Website
            </BigButton>
          </a>

          <p className={classes.EmailText}>contact@sumofame.com</p>
        </div>
      </motion.div>}
    </div>
  );
}

export default Sumofame;